module.exports = __webpack_public_path__ + "img/xprize-logo-black@4x-1024x251.6303501c.png";